module.exports = __webpack_public_path__ + "static/media/gambling.08aae669.svg";